import styled from "styled-components";

export const StyledSup = styled.sup`
    margin-left: 3px;
    font-size: 10px;
`;
